import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(screeners)/page.tsx");
